import React from 'react'
import { Admin, Resource } from 'react-admin'
import customTheme from './theme'
import i18nProvider from './i18n/i18nProvider'
import customDataProvider from './dataProvider'
import PersonIcon from '@material-ui/icons/Person'
import ListLeadProperty from './resources/LeadProperties/ListLeadProperty'
import EditLeadProperty from './resources/LeadProperties/EditLeadProperty'
import loginPage from './pages/Login'
import authProvider from './utils/authProvider'
import { CreateVisit } from './resources/LeadProperties/EditLeadProperty/Visits/createVisit'
import { EditVisit } from './resources/LeadProperties/EditLeadProperty/Visits/editVisit'
import ListLeadInspection from './resources/LeadInspections/ListLeadInspection'
import CollectionsIcon from '@material-ui/icons/Collections'

const App = () => (
  <Admin
    theme={customTheme}
    dataProvider={customDataProvider}
    i18nProvider={i18nProvider}
    loginPage={loginPage}
    authProvider={authProvider}
  >
    <Resource
      name="leadProperties"
      list={ListLeadProperty}
      edit={EditLeadProperty}
      icon={PersonIcon}
      options={{ label: 'Lead Properties' }}
    />
    <Resource
      name="leadInspections"
      list={ListLeadInspection}
      edit={EditLeadProperty}
      icon={CollectionsIcon}
      options={{ label: 'Inspections' }}
    />
    <Resource name="properties" />
    <Resource name="users" />
    <Resource name="runners" />
    <Resource name="events" />
    <Resource name="visits" create={CreateVisit} edit={EditVisit} />
  </Admin>
)
export default App
